import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class LimiteExposicao extends BaseEntity {
	idAgente: number;
	nomeAgente:  string;
	siglaAgente: string;
	cnpj: string;
	valorLimite: number;
	valorExposicaoAtual: number;
	valorDisponivel: number;
	valorLimiteLegado: number;
	mensagem: string;
}

export class LimiteLegadoDTO {
	dataImportacao: string;
	usuarioImportacao:  string;
}